import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  token:JSON.parse(localStorage.getItem('authUser'))?.token ?? '',
  success:false
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
      case RESET_USER_PASSWORD:
        state = {
          loading: true,
        }
        break
        case RESET_USER_PASSWORD_SUCCESS:
          state = {
            loading: false,
            success:true
          }
          break
    case LOGIN_SUCCESS:
      state = {
        ...action.payload,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload?.message, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
